import { NewFilter } from '@/types/NewFilter';

export const filters: NewFilter[] = [
	{
		key: 'management',
		name: 'Gerência',
		isMulti: false,
		isDisabled: () => false,
	},
	{
		key: 'board',
		name: 'Diretoria',
		isMulti: false,
		isDisabled: () => false,
	},
	{
		key: 'company',
		name: 'Empresa',
		isMulti: false,
		isDisabled: () => false,
	},
	{
		key: 'workStation',
		name: 'Local de Trabalho',
		isMulti: true,
		isDisabled: () => false,
	},
	{
		key: 'teamStructure',
		name: 'Estrutura de Turma',
		isMulti: true,
		isDisabled: () => false,
	},
	{
		key: 'role',
		name: 'Cargo',
		isMulti: true,
		isDisabled: () => false,
	},
];
